module.exports = __webpack_public_path__ + "img/middlesbrough-council.da045577.jpeg";